import * as types from './types'

export default {
  [types.UNREAD_FINANCIAL_BATCHES]: state => state.unread,
  [types.RECENT_FINANCIAL_BATCHES]: state => state.recent,
  [types.FINANCIAL_BATCH_ACKNOWLEDGE_MODAL]: state => state.acknowledgeModal,
}
